var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "section woning-selector",
      class: "view-" + this.activeView,
    },
    [
      _c(
        "svg",
        {
          class: [
            "woning-selector__overlay",
            { "-active": this.activeView === "1" },
          ],
          attrs: {
            id: "Group_545",
            "data-name": "Group 545",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            width: "1920",
            height: "1166",
            viewBox: "0 0 1920 1166",
          },
        },
        [
          _c("defs", [
            _c("clipPath", { attrs: { id: "clip-path" } }, [
              _c("rect", {
                attrs: {
                  id: "Rectangle_480",
                  "data-name": "Rectangle 480",
                  width: "1359.02",
                  height: "979.731",
                  fill: "#083438",
                },
              }),
            ]),
            _vm._v(" "),
            _c("clipPath", { attrs: { id: "clip-path-2" } }, [
              _c("rect", {
                attrs: {
                  id: "Rectangle_480-2",
                  "data-name": "Rectangle 480",
                  width: "1356.892",
                  height: "979.731",
                  fill: "none",
                  stroke: "#fff",
                  "stroke-width": "4",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("path", {
            class: _vm.getStatusClass(83),
            attrs: {
              mouseout: "resetBuilding()",
              id: "Path_162",
              "data-name": "Path 162",
              d: "M983.094,112.569l29.788,47.112L936.861,177.7,956.767,206.4c-3.712.681-12.141,11.155-12.141,11.155l-8.787,1.686-4.645,22.83L911.7,220.888,150.65,386.182V314.089l41.516-124.567L812.957,1.165,906.14,130.789Z",
              transform: "translate(680.5 109.502)",
              fill: "#083438",
              opacity: "0.1",
            },
            on: {
              click: function ($event) {
                return _vm.setRoute(83)
              },
              mouseover: function ($event) {
                return _vm.selectBuilding(83)
              },
              mouseout: function ($event) {
                return _vm.resetBuilding()
              },
            },
          }),
          _vm._v(" "),
          _c("g", { attrs: { id: "Group_544", "data-name": "Group 544" } }, [
            _c(
              "g",
              {
                attrs: {
                  id: "Group_522",
                  "data-name": "Group 522",
                  transform: "translate(560.98 108.578)",
                },
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      id: "Group_489",
                      "data-name": "Group 489",
                      "clip-path": "url(#clip-path)",
                    },
                  },
                  [
                    _c("path", {
                      class: _vm.getStatusClass(1),
                      attrs: {
                        id: "Path_94",
                        "data-name": "Path 94",
                        d: "M267.543,399.735V628.084L1,616.481v-196.3Z",
                        transform: "translate(0.781 317.135)",
                        fill: "#083438",
                        opacity: "0.1",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.setRoute(1)
                        },
                        mouseover: function ($event) {
                          return _vm.selectBuilding(1)
                        },
                        mouseout: function ($event) {
                          return _vm.resetBuilding()
                        },
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("path", {
              class: _vm.getStatusClass(2),
              attrs: {
                mouseout: "resetBuilding()",
                id: "Path_158",
                "data-name": "Path 158",
                d: "M460.543,386.575V651.9L150.65,638.525V410.175Z",
                transform: "translate(680.5 415.272)",
                fill: "#083438",
                opacity: "0.1",
              },
              on: {
                click: function ($event) {
                  return _vm.setRoute(2)
                },
                mouseover: function ($event) {
                  return _vm.selectBuilding(2)
                },
                mouseout: function ($event) {
                  return _vm.resetBuilding()
                },
              },
            }),
            _vm._v(" "),
            _c("path", {
              class: _vm.getStatusClass(3),
              attrs: {
                mouseout: "resetBuilding()",
                id: "Path_159",
                "data-name": "Path 159",
                d: "M769.047,367.655V686.174l-445.6-19.261V401.585Z",
                transform: "translate(817.594 400.262)",
                fill: "#083438",
                opacity: "0.1",
              },
              on: {
                click: function ($event) {
                  return _vm.setRoute(3)
                },
                mouseover: function ($event) {
                  return _vm.selectBuilding(3)
                },
                mouseout: function ($event) {
                  return _vm.resetBuilding()
                },
              },
            }),
            _vm._v(" "),
            _c("g", { attrs: { id: "Group_543", "data-name": "Group 543" } }, [
              _c(
                "g",
                {
                  attrs: {
                    id: "Group_523",
                    "data-name": "Group 523",
                    transform: "translate(560.98 108.578)",
                  },
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "Group_489-2",
                        "data-name": "Group 489",
                        "clip-path": "url(#clip-path-2)",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          id: "Path_94-2",
                          "data-name": "Path 94",
                          d: "M269.5,399.735V628.084L1,616.481v-196.3Z",
                          transform: "translate(0.778 317.135)",
                          fill: "none",
                          stroke: "#fff",
                          "stroke-miterlimit": "10",
                          "stroke-width": "4",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Path_163",
                  "data-name": "Path 163",
                  d: "M460.543,386.575V651.9L150.65,638.525V410.175Z",
                  transform: "translate(680.5 415.272)",
                  fill: "none",
                  stroke: "#fff",
                  "stroke-miterlimit": "10",
                  "stroke-width": "4",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Path_164",
                  "data-name": "Path 164",
                  d: "M769.047,367.655V686.174l-445.6-19.261V401.585Z",
                  transform: "translate(817.594 400.262)",
                  fill: "none",
                  stroke: "#fff",
                  "stroke-miterlimit": "10",
                  "stroke-width": "4",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Path_167",
                  "data-name": "Path 167",
                  d: "M983.094,112.569l29.788,47.112L936.861,177.7,956.767,206.4c-3.712.681-12.141,11.155-12.141,11.155l-8.787,1.686-4.645,22.83L911.7,220.888,150.65,386.182V314.089l41.516-124.567L812.957,1.165,906.14,130.789Z",
                  transform: "translate(680.5 109.502)",
                  fill: "none",
                  stroke: "#fff",
                  "stroke-miterlimit": "10",
                  "stroke-width": "4",
                },
              }),
            ]),
            _vm._v(" "),
            _c("rect", {
              attrs: {
                id: "Rectangle_494",
                "data-name": "Rectangle 494",
                width: "1920",
                height: "1166",
                fill: "none",
              },
            }),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "svg",
        {
          class: [
            "woning-selector__overlay",
            { "-active": this.activeView === "2" },
          ],
          attrs: {
            id: "Group_549",
            "data-name": "Group 549",
            xmlns: "http://www.w3.org/2000/svg",
            width: "1920",
            height: "1166",
            viewBox: "0 0 1920 1166",
          },
        },
        [
          _c("g", { attrs: { id: "Group_547", "data-name": "Group 547" } }, [
            _c("rect", {
              attrs: {
                id: "Rectangle_495",
                "data-name": "Rectangle 495",
                width: "1920",
                height: "1166",
                fill: "none",
              },
            }),
            _vm._v(" "),
            _c("g", { attrs: { id: "Group_546", "data-name": "Group 546" } }, [
              _c("path", {
                class: _vm.getStatusClass(69),
                attrs: {
                  mouseout: "resetBuilding()",
                  id: "Path_168",
                  "data-name": "Path 168",
                  d: "M230.019,163.225l.884,118.413L17.4,345.416H7.209L1.6,337.155l13.113-3.824,39.609-51.694,4.076.379V242.551l-2.038.252v-8.279H54.953l.253-2.922-1.786-2.038L159.1,188.44l12.987,3.95,2.669-1.533.253-1.912-1.263-.253v-4.329l-1.786-.884,55.391-21.518Z",
                  transform: "translate(160.246 270.099)",
                  fill: "#144549",
                  opacity: "0.1",
                },
                on: {
                  click: function ($event) {
                    return _vm.setRoute(69)
                  },
                  mouseover: function ($event) {
                    return _vm.selectBuilding(69)
                  },
                  mouseout: function ($event) {
                    return _vm.resetBuilding()
                  },
                },
              }),
              _vm._v(" "),
              _c("path", {
                class: _vm.getStatusClass(70),
                attrs: {
                  mouseout: "resetBuilding()",
                  id: "Path_169",
                  "data-name": "Path 169",
                  d: "M1109.241,435.82l-2.291,1.281v3.824l-6.367,2.291h-3.3l-2.543,1.533v9.415L1084.548,445v-3.571l-84.034-74.6-4.076.758L784.071,181.445,279.325,332.234V315.387l-3.175-.505V312s-4.744.162-4.744-4.257c0-4.4-2.038-4.581-2.038-4.581v-2.2l6.62-2.886,24.62-43.794V194.684l-3.571-.848V181.788l-1.19-.343-.162-4.581-2.561-4.022,434.8-171.8c5.609-.649,7,7,7,7L815.4,91.17,869.765,73.1l51.568,61.488-2.309.9v5.591l-1.515.649v11.58l-2.814.884v18.975l32.34-9.542,39.735,47.744-2.038.884.253,4.581-1.028.776-.253,10.57-2.8.631v8.531l23.051-5.736,21.518,25.973-1.281.631-.379,4.076-.631.649.126,5.086,10.3-2.291,28.408,33.729-2.038.9-.126,4.2-.649.379.252,3.571,8.784-1.912,16.432,19.606-1.912,1.136v3.7l-.631.379-.126,8.153-1.786.505v61.38l19.606,19.606-3.319,2.291Z",
                  transform: "translate(375.451 140.734)",
                  fill: "#144549",
                  opacity: "0.1",
                },
                on: {
                  click: function ($event) {
                    return _vm.setRoute(70)
                  },
                  mouseover: function ($event) {
                    return _vm.selectBuilding(70)
                  },
                  mouseout: function ($event) {
                    return _vm.resetBuilding()
                  },
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Path_170",
                  "data-name": "Path 170",
                  d: "M230.019,163.225l.884,118.413L17.4,345.416H7.209L1.6,337.155l13.113-3.824,39.609-51.694,4.076.379V242.551l-2.038.252v-8.279H54.953l.253-2.922-1.786-2.038L159.1,188.44l12.987,3.95,2.669-1.533.253-1.912-1.263-.253v-4.329l-1.786-.884,55.391-21.518Z",
                  transform: "translate(160.246 270.099)",
                  fill: "none",
                  stroke: "#fff",
                  "stroke-miterlimit": "10",
                  "stroke-width": "4",
                  opacity: "0.998",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Path_171",
                  "data-name": "Path 171",
                  d: "M1109.241,435.82l-2.291,1.281v3.824l-6.367,2.291h-3.3l-2.543,1.533v9.415L1084.548,445v-3.571l-84.034-74.6-4.076.758L784.071,181.445,279.325,332.234V315.387l-3.175-.505V312s-4.744.162-4.744-4.257c0-4.4-2.038-4.581-2.038-4.581v-2.2l6.62-2.886,24.62-43.794V194.684l-3.571-.848V181.788l-1.19-.343-.162-4.581-2.561-4.022,434.8-171.8c5.609-.649,7,7,7,7L815.4,91.17,869.765,73.1l51.568,61.488-2.309.9v5.591l-1.515.649v11.58l-2.814.884v18.975l32.34-9.542,39.735,47.744-2.038.884.253,4.581-1.028.776-.253,10.57-2.8.631v8.531l23.051-5.736,21.518,25.973-1.281.631-.379,4.076-.631.649.126,5.086,10.3-2.291,28.408,33.729-2.038.9-.126,4.2-.649.379.252,3.571,8.784-1.912,16.432,19.606-1.912,1.136v3.7l-.631.379-.126,8.153-1.786.505v61.38l19.606,19.606-3.319,2.291Z",
                  transform: "translate(375.451 140.734)",
                  fill: "none",
                  stroke: "#fff",
                  "stroke-miterlimit": "10",
                  "stroke-width": "4",
                  opacity: "0.998",
                },
              }),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "svg",
        {
          class: [
            "woning-selector__overlay",
            { "-active": this.activeView === "3" },
          ],
          attrs: {
            id: "Group_548",
            "data-name": "Group 548",
            xmlns: "http://www.w3.org/2000/svg",
            width: "1920",
            height: "1166",
            viewBox: "0 0 1920 1166",
          },
        },
        [
          _c("rect", {
            attrs: {
              id: "Rectangle_496",
              "data-name": "Rectangle 496",
              width: "1920",
              height: "1166",
              fill: "none",
            },
          }),
          _vm._v(" "),
          _c("path", {
            class: _vm.getStatusClass(83),
            attrs: {
              mouseout: "resetBuilding()",
              id: "Path_142",
              "data-name": "Path 142",
              d: "M327.676,212.07v3.847l-12.314-2.373-257.49,106.6V309.518l-.593-.881v-6.346l-4.836-.9L47.5,293.268l10.912-4.17,6.849-11.684-.126-9.006-4.692-.252,21.32-78.807L354.281,38.6,531.256,84.619l6.507,14.7-152.1,65.289-8.629,19.918-52.67,21.32,1.528,1.78v3.937Z",
              transform: "translate(462.952 291.878)",
              fill: "#144549",
              opacity: "0.1",
            },
            on: {
              click: function ($event) {
                return _vm.setRoute(83)
              },
              mouseover: function ($event) {
                return _vm.selectBuilding(83)
              },
              mouseout: function ($event) {
                return _vm.resetBuilding()
              },
            },
          }),
          _vm._v(" "),
          _c("path", {
            class: _vm.getStatusClass(1),
            attrs: {
              mouseout: "resetBuilding()",
              id: "Path_143",
              "data-name": "Path 143",
              d: "M0,334.33v135.36l93.889,5.393V320.311Z",
              transform: "translate(425.065 516.574)",
              fill: "#144549",
              opacity: "0.1",
            },
            on: {
              click: function ($event) {
                return _vm.setRoute(1)
              },
              mouseover: function ($event) {
                return _vm.selectBuilding(1)
              },
              mouseout: function ($event) {
                return _vm.resetBuilding()
              },
            },
          }),
          _vm._v(" "),
          _c("path", {
            class: _vm.getStatusClass(2),
            attrs: {
              mouseout: "resetBuilding()",
              id: "Path_144",
              "data-name": "Path 144",
              d: "M158.81,311.46v176.8L52.23,482.143V327.369Z",
              transform: "translate(466.724 509.514)",
              fill: "#144549",
              opacity: "0.1",
            },
            on: {
              click: function ($event) {
                return _vm.setRoute(2)
              },
              mouseover: function ($event) {
                return _vm.selectBuilding(2)
              },
              mouseout: function ($event) {
                return _vm.resetBuilding()
              },
            },
          }),
          _vm._v(" "),
          _c("path", {
            class: _vm.getStatusClass(3),
            attrs: {
              mouseout: "resetBuilding()",
              id: "Path_145",
              "data-name": "Path 145",
              d: "M111.52,321.341v176.8l149.238,8.575V299.071Z",
              transform: "translate(514.015 499.633)",
              fill: "#144549",
              opacity: "0.1",
            },
            on: {
              click: function ($event) {
                return _vm.setRoute(3)
              },
              mouseover: function ($event) {
                return _vm.selectBuilding(3)
              },
              mouseout: function ($event) {
                return _vm.resetBuilding()
              },
            },
          }),
          _vm._v(" "),
          _c("path", {
            class: _vm.getStatusClass(32),
            attrs: {
              mouseout: "resetBuilding()",
              id: "Path_146",
              "data-name": "Path 146",
              d: "M994.118,307.7v71.221l-28.6,2.786V393.5l-97.107-9.635L620.323,359.256,194.54,422.82V264.2L620.88,143.92l247.531,51.052L965.518,215V303.62Z",
              transform: "translate(580.233 375.882)",
              fill: "#144549",
              opacity: "0.1",
            },
            on: {
              click: function ($event) {
                return _vm.setRoute(32)
              },
              mouseover: function ($event) {
                return _vm.selectBuilding(32)
              },
              mouseout: function ($event) {
                return _vm.resetBuilding()
              },
            },
          }),
          _vm._v(" "),
          _c("path", {
            class: _vm.getStatusClass(61),
            attrs: {
              mouseout: "resetBuilding()",
              id: "Path_147",
              "data-name": "Path 147",
              d: "M880.711,125.689l25.76,43.089,40.518,11.774-2.031,1.528L943.43,187.4v10.157H940.9v27.683l32.735,55.816V329.79l-97.107-20.025L628.992,258.712,202.652,378.991V355.658l-3.559-1.78h-6.346V351.6s-2.229-2.211-3.11-3.11a7.341,7.341,0,0,1-1.33-1.834l-3.937-2.283,15.226-5.213,20.691-35.9V253.014l-1.78-.647v-9.509l-1.78-.5v-3.937l-1.528-1.78,52.67-21.32L276.5,195.4l152.1-65.289,20.852-8.952,44.545-105.9,17.922,5.411,5.932,7.442,111.65,35.017,112.854-47.87,5.591-8.3L765.988,0l48.841,105.268,65.864,20.421Z",
              transform: "translate(572.121 261.09)",
              fill: "#144549",
              opacity: "0.1",
            },
            on: {
              click: function ($event) {
                return _vm.setRoute(61)
              },
              mouseover: function ($event) {
                return _vm.selectBuilding(61)
              },
              mouseout: function ($event) {
                return _vm.resetBuilding()
              },
            },
          }),
          _vm._v(" "),
          _c("path", {
            class: _vm.getStatusClass(33),
            attrs: {
              mouseout: "resetBuilding()",
              id: "Path_148",
              "data-name": "Path 148",
              d: "M920.216,244.687V391.408L623.43,361.963V350.171l28.6-2.786V276.163l-28.6-4.081V183.46Z",
              transform: "translate(921.314 407.42)",
              fill: "#144549",
              opacity: "0.1",
            },
            on: {
              click: function ($event) {
                return _vm.setRoute(33)
              },
              mouseover: function ($event) {
                return _vm.selectBuilding(33)
              },
              mouseout: function ($event) {
                return _vm.resetBuilding()
              },
            },
          }),
          _vm._v(" "),
          _c("path", {
            class: _vm.getStatusClass(62),
            attrs: {
              mouseout: "resetBuilding()",
              id: "Path_149",
              "data-name": "Path 149",
              d: "M971.223,299.835l10.085,2.589V303.5s-4.692.575-4.692,2.678c0,2.085-2.481,3.29-3.811,3.29v1.4l-5.968,1.007s-3.505.575-3.505,3.523v7.963l-1.887.827v11.055L664.659,274.021V225.288l-32.735-55.816V141.789h2.535V131.632l1.528-5.321,2.031-1.528L597.5,113.009,571.74,69.92l271.242,84.128,35.2,38.918,27.4-3.379,35.071,9.545-2.157.7-.378,4.314-.953.5v8.575l-2.93.827.4,44.527Z",
              transform: "translate(880.085 316.859)",
              fill: "#144549",
              opacity: "0.1",
            },
            on: {
              click: function ($event) {
                return _vm.setRoute(62)
              },
              mouseover: function ($event) {
                return _vm.selectBuilding(62)
              },
              mouseout: function ($event) {
                return _vm.resetBuilding()
              },
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_150",
              "data-name": "Path 150",
              d: "M327.676,212.07v3.847l-12.314-2.373-257.49,106.6V309.518l-.593-.881v-6.346l-4.836-.9L47.5,293.268l10.912-4.17,6.849-11.684-.126-9.006-4.692-.252,21.32-78.807L354.281,38.6,531.256,84.619l6.507,14.7-152.1,65.289-8.629,19.918-52.67,21.32,1.528,1.78v3.937Z",
              transform: "translate(462.952 291.878)",
              fill: "none",
              stroke: "#fff",
              "stroke-width": "5",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_151",
              "data-name": "Path 151",
              d: "M0,334.33v135.36l93.889,5.393V320.311Z",
              transform: "translate(425.065 516.574)",
              fill: "none",
              stroke: "#fff",
              "stroke-width": "5",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_152",
              "data-name": "Path 152",
              d: "M158.81,311.46v176.8L52.23,482.143V327.369Z",
              transform: "translate(466.724 509.514)",
              fill: "none",
              stroke: "#fff",
              "stroke-width": "5",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_153",
              "data-name": "Path 153",
              d: "M111.52,321.341v176.8l149.238,8.575V299.071Z",
              transform: "translate(514.015 499.633)",
              fill: "none",
              stroke: "#fff",
              "stroke-width": "5",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_154",
              "data-name": "Path 154",
              d: "M994.118,307.7v71.221l-28.6,2.786V393.5l-97.107-9.635L620.323,359.256,194.54,422.82V264.2L620.88,143.92l247.531,51.052L965.518,215V303.62Z",
              transform: "translate(580.233 375.882)",
              fill: "none",
              stroke: "#fff",
              "stroke-width": "5",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_155",
              "data-name": "Path 155",
              d: "M880.711,125.689l25.76,43.089,40.518,11.774-2.031,1.528L943.43,187.4v10.157H940.9v27.683l32.735,55.816V329.79l-97.107-20.025L628.992,258.712,202.652,378.991V355.658l-3.559-1.78h-6.346V351.6s-2.229-2.211-3.11-3.11a7.341,7.341,0,0,1-1.33-1.834l-3.937-2.283,15.226-5.213,20.691-35.9V253.014l-1.78-.647v-9.509l-1.78-.5v-3.937l-1.528-1.78,52.67-21.32L276.5,195.4l152.1-65.289,20.852-8.952,44.545-105.9,17.922,5.411,5.932,7.442,111.65,35.017,112.854-47.87,5.591-8.3L765.988,0l48.841,105.268,65.864,20.421Z",
              transform: "translate(572.121 261.09)",
              fill: "none",
              stroke: "#fff",
              "stroke-width": "5",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_156",
              "data-name": "Path 156",
              d: "M920.216,244.687V391.408L623.43,361.963V350.171l28.6-2.786V276.163l-28.6-4.081V183.46Z",
              transform: "translate(921.314 407.42)",
              fill: "none",
              stroke: "#fff",
              "stroke-width": "5",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              id: "Path_157",
              "data-name": "Path 157",
              d: "M971.223,299.835l10.085,2.589V303.5s-4.692.575-4.692,2.678c0,2.085-2.481,3.29-3.811,3.29v1.4l-5.968,1.007s-3.505.575-3.505,3.523v7.963l-1.887.827v11.055L664.659,274.021V225.288l-32.735-55.816V141.789h2.535V131.632l1.528-5.321,2.031-1.528L597.5,113.009,571.74,69.92l271.242,84.128,35.2,38.918,27.4-3.379,35.071,9.545-2.157.7-.378,4.314-.953.5v8.575l-2.93.827.4,44.527Z",
              transform: "translate(880.085 316.859)",
              fill: "none",
              stroke: "#fff",
              "stroke-width": "5",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "inner" }, [
        _c(
          "div",
          { staticClass: "pointers" },
          _vm._l(_vm.activeBuildings, function (pointerBuilding) {
            return _c(
              "div",
              {
                key: pointerBuilding.id,
                staticClass: "pointer title",
                class: [
                  pointerBuilding.status === "Verkocht"
                    ? "red"
                    : pointerBuilding.status === "In optie"
                    ? "orange"
                    : pointerBuilding.status === "Verkocht o.v.b."
                    ? "pink"
                    : "",
                  pointerBuilding.id === _vm.building.id ? "active" : "",
                ],
                style: {
                  left: pointerBuilding.left + "%",
                  top: pointerBuilding.top + "%",
                },
                on: {
                  click: function ($event) {
                    return _vm.setRoute(pointerBuilding.number)
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(pointerBuilding.number) +
                    "\n            "
                ),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "woning-selector--overview" }, [
          _c("div", { staticClass: "title view-title" }, [
            _vm._v("\n                Gevel Overzicht\n            "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "views" }, [
            _c(
              "p",
              {
                staticClass: "view text",
                class: this.activeView === "1" ? "active" : "",
                on: {
                  click: function ($event) {
                    return _vm.changeView("1")
                  },
                },
              },
              [_vm._v("View 1")]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "view text",
                class: this.activeView === "2" ? "active" : "",
                on: {
                  click: function ($event) {
                    return _vm.changeView("2")
                  },
                },
              },
              [_vm._v("View 2")]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "view text",
                class: this.activeView === "3" ? "active" : "",
                on: {
                  click: function ($event) {
                    return _vm.changeView("3")
                  },
                },
              },
              [_vm._v("View 3")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "woning-selector--detail",
            class: { active: _vm.activeBuilding },
          },
          [
            _c("div", { staticClass: "title view-title" }, [
              _vm._v(
                "Type " +
                  _vm._s(this.building.type_name) +
                  " - Bouwnummer " +
                  _vm._s(this.building.number) +
                  "\n                "
              ),
              _c(
                "div",
                {
                  staticClass: "cross",
                  on: {
                    click: function ($event) {
                      return _vm.removeBuilding()
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: { src: "/images/cross-white.svg", alt: "" },
                  }),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "details" }, [
              _c("div", { staticClass: "detail" }, [
                _c("p", { staticClass: "text --small" }, [
                  _vm._v("Oppervlakte"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(this.building.surface) +
                      " m"
                  ),
                  _c("sup", [_vm._v("2")]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail" }, [
                _c("p", { staticClass: "text --small" }, [_vm._v("Kamers")]),
                _vm._v(" "),
                _c("p", { staticClass: "text" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(this.building.rooms) +
                      "\n                    "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail" }, [
                _c("p", { staticClass: "text --small" }, [
                  _vm._v("Buitenruimte"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(this.building.outdoor_space_type) +
                      "\n                    "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail" }, [
                _c("p", { staticClass: "text --small" }, [
                  _vm._v("Opp. buitenruimte"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(this.building.outdoor_surface) +
                      " m"
                  ),
                  _c("sup", [_vm._v("2")]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail" }, [
                _c("p", { staticClass: "text --small" }, [
                  _vm._v("Zonligging"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(this.building.location) +
                      "\n                    "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail" }, [
                _c("p", { staticClass: "text --small" }, [
                  _vm._v("Parkeerplaats"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(this.building.parking_lots) +
                      "\n                    "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail" }, [
                _c("p", { staticClass: "text --small" }, [_vm._v("Prijs")]),
                _vm._v(" "),
                _c("p", { staticClass: "text" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(this.building.price) +
                      "\n                    "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail" }, [
                _c("p", { staticClass: "text --small" }, [
                  _vm._v("Beschikbaarheid"),
                ]),
                _vm._v(" "),
                this.building.status === "Te koop" ||
                this.building.status === "Beschikbaar"
                  ? _c("p", { staticClass: "text green" }, [
                      _c("span", { staticClass: "dot" }),
                      _vm._v(
                        "\n                        " +
                          _vm._s(this.building.status) +
                          "\n                    "
                      ),
                    ])
                  : this.building.status === "In optie"
                  ? _c("p", { staticClass: "text orange" }, [
                      _c("span", { staticClass: "dot" }),
                      _vm._v(
                        "\n                        " +
                          _vm._s(this.building.status) +
                          "\n                    "
                      ),
                    ])
                  : this.building.status === "Verkocht"
                  ? _c("p", { staticClass: "text red" }, [
                      _c("span", { staticClass: "dot" }),
                      _vm._v(
                        "\n                        " +
                          _vm._s(this.building.status) +
                          "\n                    "
                      ),
                    ])
                  : this.building.status === "Verkocht o.v.b."
                  ? _c("p", { staticClass: "text pink" }, [
                      _c("span", { staticClass: "dot" }),
                      _vm._v(
                        "\n                        " +
                          _vm._s(this.building.status) +
                          "\n                    "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "bottom" }, [
              _c(
                "a",
                {
                  staticClass: "button -background-primary",
                  attrs: { href: this.building.type_path },
                },
                [
                  _c("span", { staticClass: "button__label" }, [
                    _vm._v("Bekijk Type " + _vm._s(this.building.type_name)),
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm._m(1),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "button__icon" }, [
      _c("img", { attrs: { src: "/images/arrow-right-white.svg", alt: "" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "woning-selector--mobile-overlay" }, [
      _c("div", { staticClass: "inner" }, [
        _c("h2", { staticClass: "title --secondary" }, [
          _vm._v("De woningselector is niet beschikbaar op mobiele apparaten"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text --white" }, [
          _vm._v(
            "Ga naar een computer voor de ervaring of bekijk het aanbod op uw mobiele apparaat"
          ),
          _c("br"),
          _c("br"),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "button --secondary --center",
            attrs: { href: "/aanbod/woningtypes" },
          },
          [
            _c("span", { staticClass: "button__label" }, [
              _vm._v("Bekijk aanbod"),
            ]),
          ]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }